var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1629 9.43802L6.10045 1.57865C6.07415 1.55795 6.04256 1.54508 6.00928 1.54153C5.976 1.53798 5.9424 1.54389 5.91233 1.55857C5.88226 1.57326 5.85694 1.59613 5.83929 1.62455C5.82163 1.65298 5.81234 1.68581 5.8125 1.71927V3.44472C5.8125 3.55409 5.86384 3.659 5.94866 3.72597L13.9844 10.0005L5.94866 16.2751C5.86161 16.342 5.8125 16.447 5.8125 16.5563V18.2818C5.8125 18.4313 5.98438 18.5139 6.10045 18.4224L16.1629 10.563C16.2485 10.4963 16.3177 10.411 16.3652 10.3135C16.4128 10.216 16.4376 10.109 16.4376 10.0005C16.4376 9.89206 16.4128 9.78502 16.3652 9.68754C16.3177 9.59007 16.2485 9.50474 16.1629 9.43802Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.6a2e96ee63fdb3f0248a049ebae0d1f8.svg";
export { ForwardRef as ReactComponent };